import { render } from "./BulkProductGridItem.vue?vue&type=template&id=476ab92e&scoped=true"
import script from "./BulkProductGridItem.vue?vue&type=script&lang=js"
export * from "./BulkProductGridItem.vue?vue&type=script&lang=js"

import "./BulkProductGridItem.vue?vue&type=style&index=0&id=476ab92e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476ab92e"]])

export default __exports__